import React from 'react';
import PropTypes from 'prop-types';
import { i18next } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import utils from 'src/js/modules/utils';
import helpers from '../helpers';
import constants from '../constants';

const { Stack, ControlGroup, CheckboxField, InputGroupField, RadioButtonGroupField } = designSystem;

const { createRequiredValidator } = utils.validators;
const {
  common: { LABEL_INPUT, PLACEHOLDER_INPUT },
  fieldControlNames,
  timeFormats,
} = constants;

const getTimeFormatOptions = () => [
  {
    label: i18next.t('12-Hour time format'),
    value: timeFormats['12_HOUR'],
    isLabelBold: true,
  },
  {
    label: i18next.t('24-Hour time format'),
    value: timeFormats['24_HOUR'],
    isLabelBold: true,
  },
];

const TimeFieldControls = ({ control, placeholders, onChangeRequiredFieldControl }) => {
  const validateRequiredField = createRequiredValidator(i18next.t('This field is required'));

  const timeFormatOptions = getTimeFormatOptions();

  return (
    <Stack gap="spacing-m">
      <ControlGroup title={i18next.t('Label')} required>
        <InputGroupField
          name={fieldControlNames.LABEL}
          control={control}
          placeholder={placeholders[LABEL_INPUT]}
          rules={{
            validate: (value) =>
              validateRequiredField(value) || helpers.validatePersonalData(value),
          }}
        />
      </ControlGroup>
      <ControlGroup title={i18next.t('Placeholder')}>
        <InputGroupField
          name={fieldControlNames.PLACEHOLDER}
          control={control}
          placeholder={placeholders[PLACEHOLDER_INPUT]}
          rules={{
            validate: helpers.validatePersonalData,
          }}
        />
      </ControlGroup>
      <ControlGroup title={i18next.t('Time format')}>
        <RadioButtonGroupField
          name={fieldControlNames.TIME_FORMAT}
          control={control}
          options={timeFormatOptions}
        />
      </ControlGroup>
      <CheckboxField
        name={fieldControlNames.REQUIRED}
        control={control}
        label={i18next.t('Make required')}
        onChange={onChangeRequiredFieldControl}
      />
    </Stack>
  );
};

TimeFieldControls.propTypes = {
  control: PropTypes.shape({}).isRequired,
  placeholders: PropTypes.shape({
    [LABEL_INPUT]: PropTypes.string,
    [PLACEHOLDER_INPUT]: PropTypes.string,
  }).isRequired,
  onChangeRequiredFieldControl: PropTypes.func.isRequired,
};

export default TimeFieldControls;
